var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProjectsRenovation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0L11 6L12.4625 3.98912C13.4183 5.05193 14 6.45804 14 8C14 11.2029 11.4904 13.8196 8.33035 13.9911L8.98018 15.9406C12.9361 15.4573 16 12.0864 16 8C16 5.79165 15.1052 3.79229 13.6584 2.3447L15 0.5L9 0Z",
    fill: "#1D58A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66965 2.00894L7.01982 0.0594482C3.06392 0.542729 0 3.91356 0 8C0 10.2084 0.894792 12.2077 2.3416 13.6553L1 15.5L7 16L5 10L3.53754 12.0109C2.58166 10.9481 2 9.54196 2 8C2 4.79714 4.50958 2.18042 7.66965 2.00894Z",
    fill: "#1D58A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProjectsRenovation);
export default __webpack_public_path__ + "static/media/icon-projects-renovation.0690da72698a9e69278a3e8a0223f720.svg";
export { ForwardRef as ReactComponent };